import { render, staticRenderFns } from "./Bookmark.vue?vue&type=template&id=7d2722dc"
import script from "./Bookmark.vue?vue&type=script&lang=ts"
export * from "./Bookmark.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports